import { useState } from 'react'
import {
  Modal,
  TextInput,
  Button,
  Stack,
  Text,
  Title,
} from '@mantine/core'
import { IconUser } from '@tabler/icons-react'
import { useSession, useApiClient } from '../../api'

function UsernamePrompt() {
  const { needsUsername, clearNeedsUsername } = useSession()
  const api = useApiClient()
  const [username, setUsername] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  const handleSubmit = async (e) => {
    e.preventDefault()
    const name = username.trim()
    if (!name) {
      setError('Please enter a display name')
      return
    }

    setLoading(true)
    setError(null)
    try {
      const result = await api.post('/api/v1/me/display-name', { display_name: name })
      clearNeedsUsername(result?.display_name || name)
    } catch (err) {
      setError(err?.message || 'Failed to set display name')
    } finally {
      setLoading(false)
    }
  }

  return (
    <Modal
      opened={needsUsername}
      onClose={() => {}}
      withCloseButton={false}
      closeOnClickOutside={false}
      closeOnEscape={false}
      centered
      size="sm"
    >
      <form onSubmit={handleSubmit}>
        <Stack gap="md" align="center">
          <IconUser size={48} color="var(--mantine-color-grape-6)" />
          <Title order={3} ta="center">
            Welcome to PediPiggy!
          </Title>
          <Text size="sm" c="dimmed" ta="center">
            Choose a display name that other users will see.
            You can change it later in your profile.
          </Text>
          <TextInput
            placeholder="Your display name"
            value={username}
            onChange={(e) => { setUsername(e.target.value); setError(null) }}
            error={error}
            required
            style={{ width: '100%' }}
            maxLength={100}
            autoFocus
          />
          <Button
            type="submit"
            fullWidth
            color="grape"
            loading={loading}
            disabled={!username.trim()}
          >
            Continue
          </Button>
        </Stack>
      </form>
    </Modal>
  )
}

export default UsernamePrompt
